import React from 'react';
import { Heart } from 'lucide-react';

/**
 * Banner shown at the bottom of pages when user is not paired with a partner.
 * Encourages them to invite a partner so they can use Tag Team's social features.
 */
export function InvitePartnerBanner({ theme, onInvite }) {
  return (
    <div style={{
      marginTop: 24,
      marginBottom: 8,
      background: `linear-gradient(135deg, ${theme.coral}15, ${theme.gold}10)`,
      border: `1px solid ${theme.coral}30`,
      borderRadius: 14,
      padding: '16px 16px 16px 18px',
      display: 'flex',
      alignItems: 'center',
      gap: 12,
    }}>
      <div style={{
        width: 40, height: 40,
        borderRadius: 12,
        background: theme.coral,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}>
        <Heart size={20} color="white" fill="white" />
      </div>

      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 13, fontWeight: 700, color: theme.text, marginBottom: 2 }}>
          Det er sjovere sammen
        </div>
        <div style={{ fontSize: 11, color: theme.textMuted, lineHeight: 1.4 }}>
          Inviter din partner og få adgang til alle funktionerne
        </div>
      </div>

      <button onClick={onInvite} style={{
        padding: '9px 14px',
        background: theme.coral,
        color: 'white',
        border: 'none',
        borderRadius: 8,
        fontSize: 12,
        fontWeight: 700,
        cursor: 'pointer',
        flexShrink: 0,
      }}>
        Inviter
      </button>
    </div>
  );
}
